import { AxiosResponse } from 'axios';

import { TPortalNavigationMenu } from '@/common/types/menu';

import { TMenuStoreState } from './types';

export function setMenu(state: TMenuStoreState, res: AxiosResponse<TPortalNavigationMenu[]>) {
  state.menu = res.data;
}
